export enum NotificationTypesEnum {
  // Broad category types (used when no specific granular type applies)
  'conversation_related' = 4,
  'detail_change' = 1,
  'document_related' = 2,
  'questionnaire_related' = 3,
  'questionnaire_document_related' = 7,
  'drop_link_related' = 8,

  // Granular Questionnaire notifications
  'questionnaire_track_changes' = 15,
  'questionnaire_submitted' = 16,

  // Granular Document notifications
  'document_uploaded_outside_questionnaire' = 17,
  'document_deleted' = 18,
  'document_moved' = 19,

  // Tax Return notifications
  'tax_return_signed' = 13,
  'tax_return_paid' = 20,
  'tax_return_draft_status_change' = 21,

  // Granular Info Change notifications
  'client_info_updated' = 22,
  'entity_info_updated' = 23,

  // Assignment notifications
  'firm_role_assigned' = 24,
  'client_assigned' = 25,

  // Signature Request notifications
  'signature_request_signed' = 27,

  // Additional Questionnaire notifications
  'questionnaire_note_added' = 28,
  'questionnaire_signature_signed' = 30,
}
